import Cropper, { CropperHandle, CropperSelection } from 'cropperjs';
import { css, html, LitElement } from 'lit';
import { customElement, query, state } from 'lit/decorators.js';
import '../components/Icons';

type CropperInstance = {};

@customElement('file-details-dialog')
export class FileDetailsDialog extends LitElement {
  static readonly styles = css`
    dialog {
      position: fixed;
      display: flex;
      flex-direction: column;
      inset: 0;
      transition: all 0.5s;
      padding: 0;
      box-shadow: 0 0 2rem 0 rgba(0, 0, 0, 0.5);
      background-color: #f7f9ff;
      color: #000;
      width: 100%;
      height: 100%;
      max-width: 90%;
      max-height: 90%;
      border: none;
      transform: scale(0.9);
      border-radius: 12px;
      overflow: hidden;
    }

    dialog[open] {
      animation: 0.5s cubic-bezier(0.35, 0.25, 0, 0.72) 0s 1 normal forwards
        running show-dialog;
    }

    dialog:not([open]) {
      display: none;
      pointer-events: none;
      opacity: 0;
    }

    dialog::backdrop {
      background-color: rgba(0, 0, 0, 0.75);
      backdrop-filter: blur(1px);
    }

    dialog header {
      margin: 0;
      padding: 0 24px;
      color: var(--media-picker-on-primary-color);
      background-color: var(--media-picker-primary-color);
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 64px;
    }

    dialog header h3 {
      margin: 0;
      margin-block-start: 0;
      margin-block-end: 0;
    }

    dialog header .dialog-header-actions {
      display: flex;
      justify-content: flex-end;
      gap: 24px;
    }

    dialog .dialog-content {
      box-sizing: border-box;
      flex: 1;
    }

    dialog footer {
    }

    dialog .dialog-content .form {
      display: flex;
      flex-direction: row;
      gap: 24px;
      flex-direction: row;
    }

    dialog .dialog-content .form .file-preview {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    dialog .dialog-content .form .file-details {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .editor cropper-canvas {
      height: 100%;
      width: 100%;
    }

    select,
    ::picker(select) {
      appearance: base-select;
    }

    select {
      border: 1px solid #ddd;
      padding: 10px;
      transition: 0.4s;
    }

    select:hover,
    select:focus {
    }

    select::picker-icon {
      transition: 0.4s rotate;
    }

    .editor-toolbar {
      position: absolute;
      bottom: 12px;
      left: 50%;
      transform: translateX(-50%);
      box-sizing: border-box;
      height: 48px;
      padding: 0 12px;

      background: #ffffff87;
      color: #000;
      border-radius: 12px;
      align-items: center;
      justify-content: center;
      display: flex;
      gap: 12px;
    }

    .editor-toolbar__button {
      box-sizing: border-box;
      cursor: pointer;
      width: 48px;
      height: 48px;

      transition: all 0.2s ease-in-out;
      background: #ffffff87;
      border: none;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    .editor-toolbar__button:hover {
      color: #3f51b5;
      transform: scale(1.1);
    }

    .editor-toolbar__button:active {
      transform: scale(0.9);
    }
  `;

  @query('dialog') _dialog!: HTMLDialogElement;

  @query('.dialog-content') _dialogContent!: HTMLDivElement;

  @query('cropper-handle') _cropperHandle!: CropperHandle;
  @query('cropper-selection') _cropperSelection!: CropperSelection;

  @state() _fileId!: string;

  @state() _cropper!: CropperInstance;

  private _openImageEditor(url: string) {
    const image = new Image();

    image.src = url;
    image.alt = 'Picture';

    this._cropper = new Cropper(image, {
      container: this._dialogContent,
    });
  }

  showModal(fileId: string) {
    this._dialog.showModal();

    this._openImageEditor(fileId);
  }

  close() {
    this._dialog.close();
  }

  private _move() {
    this._cropperHandle.action = 'move';
  }

  private _crop() {
    this._cropperHandle.action = 'crop';
  }

  override render() {
    return html`
      <dialog>
        <header>
          <h3>File Details</h3>
          <div>
            <button @click=${this.close}>Close</button>

            <select>
              <option value="edit">Free</option>
              <option value="edit">5x6 (banner lg)</option>
            </select>

            <button>Reset</button>
            <button>Apply changes</button>
            <button>Cancel</button>
          </div>
        </header>
        <div class="dialog-content editor"></div>

        <footer class="editor-toolbar">
          <button
            class="editor-toolbar__button"
            @click=${this._move.bind(this)}
          >
            <fz-icon size="24" name="move"></fz-icon>
          </button>
          <button
            class="editor-toolbar__button"
            @click=${this._crop.bind(this)}
          >
            <fz-icon size="24" name="crop"></fz-icon>
          </button>
          <button
            class="editor-toolbar__button"
            @click=${this._crop.bind(this)}
          >
            <fz-icon size="24" name="zoom-in"></fz-icon>
          </button>
          <button
            class="editor-toolbar__button"
            @click=${this._crop.bind(this)}
          >
            <fz-icon size="24" name="zoom-out"></fz-icon>
          </button>
        </footer>
      </dialog>
    `;
  }
}

// <footer>
// <button @click=${this.close}>Close</button>
// </footer>
